import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

const selectClientOrderTemplatesRoot = (state: RootState) =>
  state.data.clientOrderTemplates;

const selectClientOrderTemplates = createSelector(
  selectClientOrderTemplatesRoot,
  (temp) => temp.data
);

export const selectOrderTemplatesForClient = (clientId: string) =>
  createSelector(selectClientOrderTemplates, (data) => data[clientId] || []);

export const selectNameExists = (
  clientId: string,
  name: string,
  templateId?: string
) =>
  createSelector(selectOrderTemplatesForClient(clientId), (data) => {
    return data.some(
      (x) => x.name === name && templateId && x.id !== templateId
    );
  });

export const selectOrderTemplatesForClientTeamAndSearch = ({
  clientId,
  teamId,
  search,
}: {
  clientId: string;
  teamId: string;
  search: string;
}) =>
  createSelector(
    selectOrderTemplatesForClient(clientId),
    (data) =>
      data.filter(
        (x) =>
          (teamId ? x.teamId === teamId : true) &&
          (search ? x.name.toLowerCase().includes(search.toLowerCase()) : true)
      ) || []
  );

export const selectCurrentOrderTemplate = createSelector(
  selectClientOrderTemplatesRoot,
  (temp) => temp.selectedTemplate
);

export const selectTemplateBelongsToClient = (
  templateId: string | undefined,
  clientId: string
) =>
  createSelector(selectClientOrderTemplates, (data) =>
    templateId ? data[clientId]?.some((x) => x.id === templateId) : false
  );
